import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMProject } from "../graphql/mutations";
import {
  UpdateLLMProjectInput,
  UpdateLLMProjectMutation,
} from "../API";

export async function updateLLMProjectLogging(
  values: UpdateLLMProjectInput
): Promise<GraphQLResult<UpdateLLMProjectMutation>> {

  return API.graphql(
    graphqlOperation(updateLLMProject, {
      input: {
        id: values.id,
        logfileRetentionPeriod: values.logfileRetentionPeriod  ? values.logfileRetentionPeriod : 90,
        callRetentionPeriod: values.callRetentionPeriod ? values.callRetentionPeriod : 45,
        logInterval: values.logInterval ? values.logInterval : "none",
      },
    })
  ) as Promise<GraphQLResult<UpdateLLMProjectMutation>>;
}
